import { useMemo } from 'react';
import { observer } from 'mobx-react';

import { formatValueWithUnits } from 'pages/profile-dashboard/utilities/formatValueWithUnits';
import { useDashboardDict } from 'pages/profile-dashboard/context/useDashboardDict';
import { IUserDashboardBonus,
    IUserDashboardBonusGroup,
    IUserDashboardBonusTotal } from 'shared/models';
import { PPWDWidgetBonusTotal } from './../PPDWidget/components/PPDWidgetBonusTotal';
import { PPDModal } from '../PPDModal';

import './styles.scss';


type PPDBonusesProps = {
    isOpen?: boolean;
    onClose?: () => void;
    groups?: IUserDashboardBonusGroup[];
    items?: IUserDashboardBonus[];
    total?: IUserDashboardBonusTotal;
};

export const PPDBonuses = observer(({
    isOpen = false,
    onClose = () => {},
    groups = [],
    items = [],
    total
}:  PPDBonusesProps) => {
    const { units } = useDashboardDict();

    const groupItemsMap = useMemo(() => {
        const map: Record<string, IUserDashboardBonus[]> = {};
        items.forEach(item => {
            const key = item.group_id ?? "no_group";
            if (!map[key]) map[key] = [];
            map[key].push(item);
        });
        return map;
    }, [items]);

    const multipleGroups = groups.length > 1;

    return (
        <PPDModal className="ppd-bonuses" isOpened={isOpen} onClose={onClose}>
            <div className="ppd-bonuses__content">
                <div className="ppd-bonuses__header">
                    <h3 className="ppd-bonuses__header-title">Ваши бонусы</h3>
                </div>
                <div className="ppd-bonuses__wrapper">
                    <div className="ppd-bonuses__groups">
                        {groupItemsMap["no_group"] && (
                            <div className="ppd-bonuses__group">
                                <ul className="ppd-bonuses__list">
                                    {groupItemsMap["no_group"].map(item => (
                                        <li
                                            key={item.name}
                                            className="ppd-bonuses__item"
                                        >
                                            <span className="ppd-bonuses__item-name">{item.name}</span>
                                            <span className="ppd-bonuses__item-value">
                                                {item.value && formatValueWithUnits(item.value, units) ? formatValueWithUnits(item.value, units) : "-"}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {groups.map(group => {
                            const groupItems = groupItemsMap[group.id] || [];
                            if (!groupItems.length && !group.total) return null;

                            return (
                                <div key={group.id} className="ppd-bonuses__group">
                                    {!!groupItems.length && (
                                        <ul className="ppd-bonuses__list">
                                            {groupItems.map(item => (
                                                <li
                                                    key={item.name}
                                                    className="ppd-bonuses__item"
                                                >
                                                    <span className="ppd-bonuses__item-name">{item.name}</span>
                                                    <span className="ppd-bonuses__item-value">
                                                        {item.value && formatValueWithUnits(item.value, units)}
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}

                                    {group.total && multipleGroups &&  (
                                        <div className="ppd-bonuses__group-total">
                                            <span className="ppd-bonuses__group-total-name">
                                                {group.total.name}
                                            </span>
                                            <span className="ppd-bonuses__group-total-value">
                                                {group.total.value && formatValueWithUnits(group.total.value, units)}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    {total && (
                        <div className="ppd-bonuses__total">
                            <PPWDWidgetBonusTotal
                                name={total.name}
                                value={total.value}
                                extra={total.extra || []}
                            />
                        </div>
                    )}
                </div>

            </div>
        </PPDModal>
    );
});
